import script from "./NavigationNode.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavigationNode.vue?vue&type=script&lang=ts&setup=true"

import "./NavigationNode.vue?vue&type=style&index=0&id=8f4bc20a&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f4bc20a"]])

export default __exports__